import React from "react";
import { Modal } from "antd";

export const ModalBase = ({
  open,
  onCancel,
  title,
  children,
  footer,
  width = 520,
  footerAlign = "flex-end",
  animated = true,
  titleFontSize = "20px",
}) => (
  <Modal
    open={open}
    onCancel={onCancel}
    title={
      title ? (
        <div style={{ fontSize: titleFontSize, fontWeight: "600", lineHeight: "1.3" }}>
          {title}
        </div>
      ) : null
    }
    footer={footer}
    width={width}
    centered
    transitionName={animated ? undefined : ""}
    maskTransitionName={animated ? undefined : ""}
    styles={{
      content: { borderRadius: "12px", padding: "24px" },
      footer: {
        display: "flex",
        justifyContent: footerAlign,
        gap: "12px",
        marginTop: "20px",
      },
    }}
  >
    {children}
  </Modal>
);